import Image from 'next/image';
import underConstructionImage from './under-construction.png';
export const UnderConstruction = () => {
  return (
    <div className="py-18 container flex flex-col items-center gap-y-4 text-center">
      <div className="flex justify-center">
        <Image src={underConstructionImage} width={300} height={293.33} alt="Under Construction" />
      </div>
      <h1 className="text-title-1 font-bold">This page is under construction</h1>
      <p className="text-title-4 w-3/4 font-light">
        If you&apos;re seeing this page, you may be waiting for the next generation of information in the insurance
        industry. We&apos;re still working on it but we&apos;ll be launching soon!
      </p>
    </div>
  );
};
